<template>
  <section class="app-main" :class="{'no-padding-top': noPaddding}">
    <router-view :key="key" />
  </section>
</template>

<script>
export default {
  name: 'AppMain',
  computed: {
    key() {
      return this.$route.path
    }
  },
  watch: {
    '$route.path': {
      handler(val) {
        // console.log(val);
        this.noPaddding = this.noPaddingTopList.some(item => item === val)
      },
      immediate: true
    }
  },
  data() {
    return {
        noPaddding: false,
        noPaddingTopList: [
            '/homePage',
            '/generalIndex',
            '/zoologyIndex',
            '/biologicalAppreciation',
            '/humanityIndex',
            '/folkCulture',
            '/communityIndex',
            '/popularizationIndex',
            '/envEducationIndex'
        ]
    }
  },
  mounted() {
    // console.log(this.$route.path);
  },
}
</script>

<style scoped>
.app-main {
  /*50 = navbar  */
  min-height: calc(100vh - 60px);
  width: 100%;
  position: relative;
  overflow: hidden;
  background: #f5f3e1;
}
.fixed-header+.app-main {
  padding-top: 60px;
}
.fixed-header+.app-main.no-padding-top {
  padding-top: 0px;
  min-height: calc(100vh - 0px);
}
@media screen and (min-width: 1920px) {
    .app-main {
        min-height: calc(100vh - 80px);
    }
    .p1mapp+.app-main {
        min-height: calc(100vh);
    }
    .fixed-header+.app-main {
      padding-top: 80px;
    }
    .fixed-header+.app-main.no-padding-top {
      padding-top: 0px;
      min-height: calc(100vh - 0px);
    }
}
</style>

<style lang="scss">
// fix css style bug in open el-dialog
.el-popup-parent--hidden {
  .fixed-header {
    padding-right: 15px;
  }
}
</style>
